import React from 'react';
import { CEODen } from './pages/CEODen';
export function App() {
  return <CEODen data-id="element-0" />;
}